/* Register.js（差し替え） */
import React, { useState, useEffect, useRef } from "react";
import { createUserWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./FirebaseConfig.js"; // ← db を使う
import { Navigate, Link } from "react-router-dom";
import { Input, Button, Form, message, Spin, Checkbox, Divider, Modal } from "antd";
import "./App.css";
import { EditOutlined, UserOutlined, LockOutlined, DownOutlined } from "@ant-design/icons";
import { doc, setDoc, serverTimestamp, Timestamp } from "firebase/firestore";

const CheckboxGroup = Checkbox.Group;

const validateMessages = {
  types: { email: "有効なメールアドレスではありません。" },
};

const Register = () => {
  const [open, setOpen] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const passwordCheck = useRef(null);
  const [checkedList, setCheckedList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [termsCheck, setTermsCheck] = useState(true);
  const [user, setUser] = useState(null);

  const plainOptions = [
    { label: "私は「利用規約」を確認し承諾します。", value: "tos", disabled: termsCheck },
    { label: "私は上記の「プライバシーポリシー」の内容を確認し同意します。", value: "pp", disabled: termsCheck },
    { label: "私は反社会勢力等ではありません。", value: "as" },
  ];

  const onChange = (list) => {
    setCheckedList(list);
    setCheckAll(list.length === plainOptions.length);
  };

  const okButton = () => {
    setCheckedList(["tos", "pp"]);
    setTermsCheck(false);
    setOpen(false);
  };

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (currentUser) => setUser(currentUser));
    return () => unsub();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // 1) Firebase Authでユーザー作成
      const cred = await createUserWithEmailAndPassword(auth, registerEmail, registerPassword);
      const uid = cred.user.uid;

      // 2) Firestoreに初期プラン（Basic）を自動付与
      const now = new Date();
      const end = new Date(now.getTime() + 365 * 2 * 24 * 60 * 60 * 1000); // 30日トライアルの例

      const userDoc = {
        plan: "basic", // ← デフォルト：basic / あとで rental / academia に更新可
        createdAt: serverTimestamp(),
        subscription: {
          startAt: Timestamp.fromDate(now),
          endAt: Timestamp.fromDate(end),
          status: "active",
        },
      };

      await setDoc(doc(db, "users", uid), userDoc, { merge: true });

      message.success(`${registerEmail} として新規登録しました`);
    } catch (error) {
      console.error(error);
      message.error("登録に失敗しました。メール・パスワードをご確認ください。");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="center"
      style={{ flex: 1, justifyContent: "center", alignItems: "center", lineHeight: "100px" }}
    >

      <>
        {loading && <Spin size="large" style={{ margin: 200 }} tip="Loading" />}
        {!loading && (
          <Form name="nest-messages" validateMessages={validateMessages}>
            <h1>新規発行</h1>

            <h4>メールアドレス</h4>
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              style={{ width: 500 }}
              name="email"
              type="email"
              value={registerEmail}
              onChange={(e) => setRegisterEmail(e.target.value)}
            />

            <h4>パスワード</h4>
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              visibilityToggle={{ visible: passwordVisible, onVisibleChange: setPasswordVisible }}
              style={{ width: 500 }}
              name="password"
              value={registerPassword}
              onChange={(e) => setRegisterPassword(e.target.value)}
              ref={passwordCheck}
            />

            <br />
            <br />
            <Button type="primary" onClick={handleSubmit} icon={<EditOutlined />} >
              登録する
            </Button>

            <Divider />
          </Form>
        )}
      </>

    </div>
  );
};

export default Register;
